import { useEffect, useMemo } from 'react';
import { UnityStatusOption, useGetPropertiesForOwnerContractCreationQuery } from '@/graphql/generated';
import { LoadingSpinner } from '../atoms';
import { PropertySimpleSelectionList } from './PropertySimpleSelectionList';
import {
  useErrorHandlerContext,
  useUserLanguage,
  useCreateOwnerContractContext,
} from '@/customHooks';
import textsData from '@/textData/CreateContractsTexts.json';

export const SelectOwnerContractPropertyMenu = () => {
  const { setProperty, state } = useCreateOwnerContractContext();
  const userLanguage = useUserLanguage();

  const rootTexts = userLanguage === 'es' ? textsData.es : textsData.en;
  const texts = rootTexts.ownerContract.selectProperty;

  const {data, loading, error} = useGetPropertiesForOwnerContractCreationQuery({
    variables: {
      ownerId: state.ownerId ?? '',
    },
  })

  const { open: ErrorHandlerContextOpen } = useErrorHandlerContext()

  const handlePropertySelected = (propertyId: string | null, propertyName?: string | null) => {
    if (propertyId) {
      setProperty(propertyId, propertyName ?? '')
    }
  };

  const propertiesForSimpleList = useMemo(() => {
    return data?.propertiesByOwner?.map((property) => ({
      id: property.id,
      name: property.name,
      street: property.address.street,
      city: property.address.city?.name ?? '',
      state: property.address.state?.name ?? '',
      status: property.occupancyStatusOption,
    }))
  }, [data])

  useEffect(() => {
    if (error) ErrorHandlerContextOpen(error)
  }, [error])

  if (loading) {
    return (
      <div className="flex justify-center p-12">
        <LoadingSpinner />
      </div>
    )
  }
  return (
    <div className="flex justify-center w-full">
      <div className="w-full max-w-5xl flex flex-col gap-6">
        <div className="text-center">
          <h2 className="text-xl font-bold text-gray-900 mb-2">{texts.title}</h2>
          <p className="text-sm text-gray-500">{texts.helper}</p>
        </div>
        <div className="flex justify-center">
          <div className="w-full">
            <PropertySimpleSelectionList
              selected={(property) => handlePropertySelected(property.id, property.name)}
              properties={propertiesForSimpleList}
              disabledOn={(property) => property.status === UnityStatusOption.NotAvailable}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
